import React, { useEffect, useState } from 'react'
import { InputGroup, FormControl, ButtonGroup, Badge } from 'react-bootstrap';
import Button from "react-bootstrap/Button";
import { getDatabase, ref, get, update, set } from 'firebase/database';

function randomToken(length = 16, prefix = "000") {
    return prefix + Array.from(crypto.getRandomValues(new Uint8Array(length)))
        .map(b => b.toString(16).padStart(2, '0'))
        .join('');
}

function isoToLocalString(isoDate) {
    const d = new Date(isoDate);
    const pad = n => String(n).padStart(2, '0');

    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ` +
        `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function UnnatendedAccess({ companie: company }) {

    const [token, setToken] = useState()
    const [shared, setShared] = useState(false)
    const [baseUrl] = useState(
        `${window.location.protocol}//${window.location.host}`
    )
    const [url, setUrl] = useState(baseUrl);
    const [lastAccess, setLastAccess] = useState(undefined)
    const [created, setCreated] = useState(false)

    const copyToClipboard = () => {
        if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
            // Modern API (requires HTTPS or localhost)
            navigator.clipboard.writeText(url)
                .then(() => console.log("Copied:", url))
                .catch(err => console.error("Failed to copy:", err));
        } else {
            // Fallback for insecure origins / older browsers
            const tempInput = document.createElement("input");
            tempInput.value = url;
            document.body.appendChild(tempInput);
            tempInput.select();
            try {
                document.execCommand("copy");
                console.log("Copied (fallback):", url);
            } catch (err) {
                console.error("Fallback copy failed:", err);
            }
            document.body.removeChild(tempInput);
        }
    };


    const createUnnatendedAccess = () => {
        const path = `/unnatendedAccess/${company}/${token}`
        const now = new Date()

        let data = {
            'created': now.toISOString()
        }

        const db = getDatabase()
        set(ref(db, path), data)

        setCreated(isoToLocalString(now.toISOString()))
    }

    const createRolesEntry = () => {
        const path = `/roles/${token}`

        const data = {
            0: "externo",
            "company": company
        }

        const db = getDatabase()
        set(ref(db, path), data)
    }

    const deleteRolesEntry = () => {
        const path = `/roles/${token}`

        const db = getDatabase()
        set(ref(db, path), null)
    }

    const setInterfaceToken = (newToken = randomToken()) => {
        setToken(newToken)
        let nUrl = `${baseUrl}/ua/${newToken}`
        setUrl(nUrl)
    }

    const getCurrentUnnatendedAccess = () => {
        const path = `/unnatendedAccess/${company}`

        const db = getDatabase()

        get(ref(db, path)).then((snapshot) => {
            if (snapshot.exists()) {
                const val = snapshot.val()

                for (const [t, tokenData] of Object.entries(val)) {

                    const tokenDataKeys = Object.keys(tokenData)

                    if (!tokenDataKeys.includes('revoked')) {
                        setInterfaceToken(t)
                        setShared(true)
                        if (tokenDataKeys.includes("created")) {
                            setCreated(isoToLocalString(tokenData["created"]))
                        }

                        if (tokenDataKeys.includes("lastAccess")) {
                            setLastAccess(isoToLocalString(tokenData["lastAccess"]))
                        }

                        return
                    }
                }

                setInterfaceToken()
            } else {
                setInterfaceToken()
            }
        })
    }

    const share = () => {
        setShared(true)

        createUnnatendedAccess()
        createRolesEntry()
    }

    const deleteShare = () => {
        const path = `/unnatendedAccess/${company}/${token}/revoked`

        const db = getDatabase()
        set(ref(db, path), new Date().toISOString())

        deleteRolesEntry()

        setInterfaceToken()
        setShared(false)
        setLastAccess(undefined)
        setCreated(false)
    }

    useEffect(() => {
        getCurrentUnnatendedAccess()
    }, [])

    return (
        <div className='mb-3'>
            <span className='fw-semibold'>Acesso Externo</span>
            <InputGroup className="">
                <FormControl value={url} readOnly />
                {shared && <ButtonGroup>
                    <Button variant="danger" onClick={deleteShare}>
                        <i className="bi bi-trash" />
                    </Button>
                    <Button variant="primary" onClick={copyToClipboard}>
                        <i className="bi bi-clipboard" />
                    </Button>
                </ButtonGroup>}
                {!shared && <ButtonGroup>
                    <Button variant="success" onClick={share}>
                        <i className="bi bi-share-fill" />
                    </Button>
                </ButtonGroup>}
            </InputGroup>
            <ShareStatus shared={shared} />
            {created && <div>
                Compartilhado em:
                <i> {created}</i>
            </div>}
            {lastAccess && <div>
                Último acesso:
                <i> {lastAccess}</i>
            </div>}
        </div>
    )
}

function ShareStatus({ shared }) {
    return (
        <div className="d-flex align-items-center gap-2">
            Link compartilhado:{" "}
            {shared ? (
                <Badge bg="success" className="d-flex align-items-center">
                    <i className="bi bi-check me-1"></i> Sim
                </Badge>
            ) : (
                <Badge bg="danger" className="d-flex align-items-center">
                    <i className="bi bi-x me-1"></i> Não
                </Badge>
            )}
        </div>
    );
}

export default UnnatendedAccess